import Player from './Player';

class App
{
  // ---------------------------------------------------------------------------------------------------------
	// --	App
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    $('.video-player').each(function(index){
      new Player($(this))
    })
  }
  
	// ---------------------------------------------------------------------------------------------------------
}

// var app;
$(function(){
  new App();
});
